import { GxIcon } from "./icon.js"



export class GxIconLocation extends GxIcon {

  constructor() {
    super()
    const temp = document.createElement("template")
    temp.innerHTML = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin h-6 w-6 text-green-600" aria-hidden="true">
  <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
  <circle cx="12" cy="10" r="3"></circle>
</svg>
`
    super.addHTML(temp)
  }
}


if (!window.customElements.get("gx-icon-location")) window.customElements.define("gx-icon-location", GxIconLocation)
